import api from './api';

export default {
  getProductSuitabilities() {
    return new Promise((resolve, reject) => {
      api
        .get(`product-suitability`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  updateProductSuitability(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`product-suitability/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  addProductSuitability(productSuitability) {
    return new Promise((resolve, reject) => {
      api
        .post(`product-suitability`, productSuitability)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  deleteProductSuitability(id) {
    return new Promise((resolve, reject) => {
      api
        .delete(`product-suitability/${id}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
